import React, { useState } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"
import { postEndGame, postResult } from "../../api"
import PlayerBox from "./PlayerBox"
import styles from "./WinnerChooser.module.scss"

function WinnerChooser({ onLeave, setLoading }) {
	const [winner, setWinner] = useState()

	const onDone = () => {
		const homeTeam = JSON.parse(localStorage.getItem("homeTeam") ?? "{}")
		const isHomeTeam =
			(winner.playerId ?? winner._id) == (homeTeam.playerId ?? homeTeam._id)

		const game = JSON.parse(localStorage.getItem("gameDetails") ?? "{}").gameId
		const sport = localStorage.getItem("sport")

		if (!game || !sport || !winner) return
		setWinner()

		postResult({
			sport,
			game,
			isHomeTeam,
		}).then(({ error, offline }) => {
			if (!error && !offline)
				postEndGame({ game, sport }).then(({ error, offline }) => {
					setLoading(false)
					if (!error && !offline) {
						setWinner()
						onLeave(true)
					}
				})
			else setLoading(false)
		})
		setLoading(true)
	}

	return (
		<div className={styles.wrapper}>
			<PlayerBox
				team={JSON.parse(localStorage.getItem("homeTeam") ?? "{}")}
				setWinner={setWinner}
			/>
			<PlayerBox
				team={JSON.parse(localStorage.getItem("awayTeam") ?? "{}")}
				setWinner={setWinner}
			/>

			<Modal
				isOpen={!!winner}
				toggle={() => setWinner()}
				className="modal-dialog-centered"
			>
				<ModalHeader toggle={() => setWinner()}>
					Jesi li siguran?
				</ModalHeader>
				<ModalBody>
					<br />
					<h2>
						Pobjednik je {winner?.name} {winner?.surname ?? ""}!
					</h2>
					<br />
					<p>
						Jel to točno?{" "}
						<span style={{ color: "red" }}>
							Ovo se nemože poništiti.
						</span>
					</p>
				</ModalBody>
				<ModalFooter>
					<Button.Ripple color="primary" outline onClick={onDone}>
						Spremi i izađi iz utakmice
					</Button.Ripple>
					<Button.Ripple color="secondary" onClick={() => setWinner()}>
						Odustani
					</Button.Ripple>
				</ModalFooter>
			</Modal>
		</div>
	)
}

export default WinnerChooser
